import React from 'react';
import { CopyableBlock } from './CopyableBlock';

const stringify = (val) => {
  if (val == null) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return val.map((v) => (typeof v === 'string' ? `• ${v}` : JSON.stringify(v, null, 2))).join('\n');
  if (typeof val === 'object') return JSON.stringify(val, null, 2);
  return String(val);
};

export const RadioFormat = ({ data }) => {
  if (!data) return <p className="text-sm text-gray-500">No radio format available.</p>;

  // Supports rich seed shape ({intro, three_min, host_cues, audience_takeaway}) AND fallback ({script, duration}).
  const intro = data.intro;
  const threeMin = data.three_min || data.script;
  const hostCues = data.host_cues;
  const takeaway = data.audience_takeaway;
  const duration = data.duration;

  const composedScript = [
    intro && `[INTRO — 5s]\n${intro}`,
    threeMin && `[BODY${duration ? ' — ' + duration : ''}]\n${threeMin}`,
    Array.isArray(hostCues) && hostCues.length ? `[HOST CUES]\n${hostCues.map((c) => '• ' + c).join('\n')}` : null,
    takeaway && `[AUDIENCE TAKEAWAY]\n${takeaway}`,
  ]
    .filter(Boolean)
    .join('\n\n');

  return (
    <div data-testid="radio-format">
      <CopyableBlock label="Intro" content={stringify(intro)} testId="copy-radio-intro" />
      <CopyableBlock
        label={duration ? `Body Script (${duration})` : 'Body Script (3-min)'}
        content={stringify(threeMin)}
        testId="copy-radio-body"
      />
      {Array.isArray(hostCues) && hostCues.length > 0 && (
        <CopyableBlock label="Host Cues" content={hostCues.map((c) => `• ${c}`).join('\n')} testId="copy-radio-cues" />
      )}
      <CopyableBlock label="Audience Takeaway" content={stringify(takeaway)} testId="copy-radio-takeaway" />
      {composedScript && (
        <CopyableBlock label="Full Script (compose)" content={composedScript} mono testId="copy-radio-full" />
      )}
    </div>
  );
};

export default RadioFormat;
